import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { listerClickThrough } from '../../../../actions/lister-actions';
import { useIsProductInHighDemand } from '../../../../hooks/useIsProductInHighDemand';
import AddToBasketButton from '../../../ProductCard/AddToBasket/AddToBasketButton';
import BackInStockButton from '../../../ProductCard/BackInStockButton';
import BrandLogo from '../../../ProductCard/BrandLogo';
import Bullets from '../../../ProductCard/Bullets';
import DeliveryInformation from '../../../ProductCard/DeliveryInformation';
import EnergyInformation from '../../../ProductCard/EnergyInformation/EnergyInformation';
import NewEnergyInformation from '../../../ProductCard/EnergyInformation/NewEnergyInformation';
import Heading from '../../../ProductCard/Heading';
import HighDemandFlag from '../../../ProductCard/HighDemand/HighDemandFlag';
import HighDemandMessaging from '../../../ProductCard/HighDemand/HighDemandMessaging';
import MoreInfo from '../../../ProductCard/MoreInfo';
import PricePod from '../../../ProductCard/PricePod/PricePod@default';
import ProductImage from '../../../ProductCard/ProductImage/ProductImage';
import PromoFlag from '../../../ProductCard/PromoFlag';
import ReviewRating from '../../../ProductCard/ReviewRating/ReviewRating';
import StockStatus from '../../../ProductCard/StockStatus';
import TradingRangeFlag from '../../../ProductCard/TradingRangeFlag/TradingRangeFlag';
import { Context } from '../../store/store';
import SmallListViewSkeleton from './Skeletons/SmallListViewSkeleton';

export const SmallListViewContent = ({ product, tradingRangeInfo }) => {
	const [contextState] = useContext(Context);
	const { loaded } = contextState;

	const { ListerProductCardEnergyLabelEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const dispatch = useDispatch();

	const isSkuHighDemand = useIsProductInHighDemand(product);

	if (!product) {
		return null;
	}

	if (!loaded) {
		return <SmallListViewSkeleton />;
	}

	return (
		<>
			{loaded && tradingRangeInfo && <TradingRangeFlag {...tradingRangeInfo} />}

			<div className="w-5/12 pr-2 z-10" style={{ height: 'fit-content' }}>
				<ProductImage {...product} />

				<EnergyInformation
					classes="text-center mt-4"
					energyRatingDetails={product.EnergyRatingDetails}
				/>

				{isSkuHighDemand && <HighDemandFlag classes="mt-4" />}
			</div>

			<div className="w-7/12 z-10">
				<a
					href={product.FullProductUrl}
					onClick={(event) => {
						event.preventDefault();
						window.location.assign(product.FullProductUrl);

						dispatch(listerClickThrough(product.Code));
					}}
					className="inline-block"
					itemProp="url"
					data-testid="product-card-link">
					<BrandLogo {...product} />

					<Heading content={product.FullTitle} />
				</a>

				<ReviewRating {...product} />

				<PricePod
					product={product}
					viewModel={product.PricePodViewModel}
					inStock={product.State !== 'OutOfStock'}
					{...product}
				/>

				{ListerProductCardEnergyLabelEnabled && (
					<NewEnergyInformation
						energyRatingDetails={product.EnergyRatingDetails}
					/>
				)}

				<PromoFlag {...product} />

				<Bullets content={product.FeatureDescriptions} />

				{product.State !== 'OutOfStock' ? (
					<>
						{!isSkuHighDemand && (
							<DeliveryInformation
								deliveryInformation={product.DynamicDeliveryBulletsViewModel}
							/>
						)}

						{isSkuHighDemand && <HighDemandMessaging classes="my-2" />}

						{!isSkuHighDemand && (
							<AddToBasketButton classes="mt-2" {...product} />
						)}

						<MoreInfo classes="mt-2" {...product} />
					</>
				) : (
					<>
						<StockStatus
							stockStatus={product.State}
							productCode={product.Code}
						/>

						<BackInStockButton classes="mt-4" {...product} />
					</>
				)}
			</div>
		</>
	);
};

export default SmallListViewContent;
